import React, { useState, useMemo } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { AuthingButtonArrow } from "../../components/AuthingButton";
import { MobileMenu } from "../../components/Footer/MobileFooter/MobileMenu";

export const HomePageMultiply = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const catalogue = useMemo(() => {
    return [
      {
        index: "01",
        title: t("homePage.multiply.catalogue1.title"),
        subtitle: t("homePage.multiply.catalogue1.subtitle"),
        text: t("homePage.multiply.catalogue1.text"),
        subtext: t("homePage.multiply.catalogue1.subtext"),
        bgImg: "https://files.authing.co/authing-website/home-0915-6-bg1-e.jpg",
        contentLists: [
          {
            title: t("homePage.multiply.catalogue1.contentLists1.title"),
            time: "2022.04",
            logo: `https://files.authing.co/authing-website/${t(
              "homePage.multiply.catalogue1.compliance1"
            )}`,
            desc: t("homePage.multiply.catalogue1.contentLists1.desc"),
            clickUrl:
              "https://www.authing.cn/blog/343?keyword=%E4%BF%A1%E6%81%AF%E5%AE%89%E5%85%A8&page=1",
          },
          {
            title: t("homePage.multiply.catalogue1.contentLists2.title"),
            time: "2021.07",
            logo: `https://files.authing.co/authing-website/${t(
              "homePage.multiply.catalogue1.compliance2"
            )}`,
            desc: t("homePage.multiply.catalogue1.contentLists2.desc"),
          },
          {
            title: t("homePage.multiply.catalogue1.contentLists3.title"),
            time: "2019.09",
            logo: `https://files.authing.co/authing-website/${t(
              "homePage.multiply.catalogue1.compliance4"
            )}`,
            desc: t("homePage.multiply.catalogue1.contentLists3.desc"),
            clickUrl:
              "https://www.authing.cn/blog/99?keyword=%E9%AB%98%E6%96%B0%E6%8A%80%E6%9C%AF&page=2",
          },
          {
            title: t("homePage.multiply.catalogue1.contentLists4.title"),
            time: "2019.09",
            logo: `https://files.authing.co/authing-website/${t(
              "homePage.multiply.catalogue1.compliance7"
            )}`,
            desc: t("homePage.multiply.catalogue1.contentLists4.desc"),
            clickUrl: "https://mp.weixin.qq.com/s/SeT3bsPWgnwSfpXqoa3tag",
          },
          {
            title: t("homePage.multiply.catalogue1.contentLists5.title"),
            time: "2021.07",
            logo: `https://files.authing.co/authing-website/${t(
              "homePage.multiply.catalogue1.compliance5"
            )}`,
            desc: t("homePage.multiply.catalogue1.contentLists5.desc"),
          },
          {
            title: t("homePage.multiply.catalogue1.contentLists4.title"),
            time: "2019.09",
            logo: `https://files.authing.co/authing-website/${t(
              "homePage.multiply.catalogue1.compliance3"
            )}`,
            desc: t("homePage.multiply.catalogue1.contentLists4.desc"),
            clickUrl: "https://mp.weixin.qq.com/s/SeT3bsPWgnwSfpXqoa3tag",
          },
          {
            title: t("homePage.multiply.catalogue1.contentLists5.title"),
            time: "2021.07",
            logo: `https://files.authing.co/authing-website/${t(
              "homePage.multiply.catalogue1.compliance6"
            )}`,
            desc: t("homePage.multiply.catalogue1.contentLists5.desc"),
          },
        ],
      },
      {
        index: "02",
        title: t("homePage.multiply.catalogue2.title"),
        subtitle: t("homePage.multiply.catalogue2.subtitle"),
        text: t("homePage.multiply.catalogue2.text"),
        subtext: t("homePage.multiply.catalogue2.subtext"),
        bgImg: "https://files.authing.co/authing-website/home-0915-6-bg2-e.jpg",
        icon:
          "https://files.authing.co/authing-website/home-0830-6-logo-3-t.png",
        clickUrl: "https://www.authing.cn/blog/335?keyword=W3C&page=1",
      },
      {
        index: "03",
        title: t("homePage.multiply.catalogue3.title"),
        subtitle: t("homePage.multiply.catalogue3.subtitle"),
        text: t("homePage.multiply.catalogue3.text"),
        subtext: t("homePage.multiply.catalogue3.subtext"),
        bgImg: "https://files.authing.co/authing-website/home-0915-6-bg3-e.jpg",
        icon:
          "https://files.authing.co/authing-website/home-0830-6-logo-2-t-t.png",
        clickUrl: "https://www.authing.cn/blog/310?keyword=CNCF&page=1",
      },
      {
        index: "04",
        title: t("homePage.multiply.catalogue4.title"),
        subtitle: t("homePage.multiply.catalogue4.subtitle"),
        text: t("homePage.multiply.catalogue4.text"),
        subtext: t("homePage.multiply.catalogue4.subtext"),
        bgImg: "https://files.authing.co/authing-website/home-0915-6-bg4-e.jpg",
        icon:
          "https://files.authing.co/authing-website/home-0830-6-logo-1-t.png",
        clickUrl:
          "https://www.authing.cn/blog/258?keyword=%E7%A6%8F%E5%B8%83%E6%96%AF&page=1",
      },
    ];
  }, [t]);
  const content = useMemo(() => {
    return catalogue.map((item, index) => {
      const className = classNames({
        "home-page-multiply-content": true,
        visible: currentIndex === index,
      });
      return (
        <div
          className={className}
          style={{
            textAlign: item.contentLists ? "left" : "center",
          }}
        >
          {item.icon && (
            <i className="multiply-content-icon" style={item.iconStyle}>
              <img src={item.icon} />
            </i>
          )}
          <div className="multiply-content-title">{item.text}</div>
          <div
            className="multiply-content-subtitle"
            style={{
              textAlign: index === 0 ? "left" : "center",
            }}
          >
            {item.subtext}
          </div>
          {!item.contentLists ? (
            <AuthingButtonArrow
              mode={"color-white"}
              style={{ marginTop: 16 }}
              className="multiply-content-link"
              onClick={() => {
                item.clickUrl && window.open(item.clickUrl);
              }}
            >
              {t("homePage.multiply.button-text")}
            </AuthingButtonArrow>
          ) : (
            <div className="multiply-content-lists">
              {item.contentLists.map((itemContent) => (
                <div
                  className="multiply-content-lists-logo"
                  key={itemContent.desc}
                  onClick={() => {
                    itemContent.clickUrl && window.open(itemContent.clickUrl);
                  }}
                  style={{
                    cursor: itemContent.clickUrl ? "pointer" : "",
                  }}
                >
                  <img src={itemContent.logo} />
                </div>
              ))}
            </div>
          )}
        </div>
      );
    });
  }, [catalogue, currentIndex, t]);
  const contentMobile = useMemo(() => {
    return catalogue.map((item, index) => {
      return (
        <MobileMenu
          key={`mobile-menu-${index}`}
          dataSource={{
            name: `0${index + 1}        ${item.title}`,
            active: index === 0,
            render: (
              <div
                className={`home-page-multiply-content basic-column ${
                  "tab" + index
                }`}
                style={{
                  textAlign: item.contentLists ? "left" : "center",
                }}
              >
                {item.icon && (
                  <i className="multiply-content-icon" style={item.iconStyle}>
                    <img src={item.icon} />
                  </i>
                )}
                <div className="multiply-content-title">{item.text}</div>
                <div
                  className="multiply-content-subtitle"
                  style={{
                    textAlign: index === 0 ? "left" : "center",
                  }}
                >
                  {item.subtext}
                </div>
                {!item.contentLists ? (
                  <AuthingButtonArrow
                    mode={"color-white"}
                    style={{ marginTop: 16 }}
                    className="multiply-content-link"
                    onClick={() => {
                      item.clickUrl && window.open(item.clickUrl);
                    }}
                  >
                    {t("homePage.multiply.button-text")}
                  </AuthingButtonArrow>
                ) : (
                  <div className="multiply-content-lists">
                    {item.contentLists.map((itemContent) => (
                      <div
                        className="multiply-content-lists-logo"
                        key={itemContent.desc}
                        onClick={() => {
                          itemContent.clickUrl &&
                            window.open(itemContent.clickUrl);
                        }}
                        style={{
                          cursor: itemContent.clickUrl ? "pointer" : "",
                        }}
                      >
                        <img src={itemContent.logo} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ),
          }}
        />
      );
    });
  }, [catalogue, t]);
  const links = useMemo(() => {
    return catalogue.map((item, index) => {
      const className = classNames({
        "multiply-catalogue-item": true,
        active: currentIndex === index,
      });
      return (
        <div className={className} onClick={() => setCurrentIndex(index)}>
          <div className="multiply-catalogue-item-index">{item.index}</div>
          <div className="multiply-catalogue-item-content">
            <div className="multiply-catalogue-item-title">{item.title}</div>
            <div className="multiply-catalogue-item-subtitle">
              {item.subtitle}
            </div>
          </div>
        </div>
      );
    });
  }, [catalogue, currentIndex]);
  return (
    <div className="home-page-multiply">
      <div
        className="home-page-multiply-warp"
        style={{ backgroundImage: `url(${catalogue[currentIndex].bgImg})` }}
      >
        <div className="home-page-multiply-title basic-title">
          {t("homePage.multiply.title")}
        </div>
        <div className="home-page-multiply-warp-inner">
          <div className="home-page-multiply-warp-flex basic-column  home-page-multiply-content-warp-pc">
            <div className="home-page-multiply-content-warp">{content}</div>
            <div className="home-page-multiply-catalogue">{links}</div>
          </div>
          <div className="home-page-multiply-warp-flex home-page-multiply-content-warp-mobile">
            <div className="home-page-multiply-content-warp">
              {contentMobile}
            </div>
            <div className="home-page-multiply-catalogue">{links}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
